module.exports = require('./helpers/bundle-url').getBundleURL('5vUwe') + "empty-state.c4e885df.svg";